module.exports = __webpack_public_path__ + "42df38fc5053c1bec9d54535c0ecd6c2.png";